import { lazy } from 'react';

import { Loadable } from '@trendiolive/trendio-selfcare-ui-kit';

// project import
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';

const DataAnalytics = Loadable(lazy(() => import('pages/data-analytics')));
const DataAnalyticsTiktokTab = Loadable(lazy(() => import('features/data-analytics/components/TTSDashboardPresentationResult')));
const DataAnalyticsYoutubeTab = Loadable(lazy(() => import('features/data-analytics/components/YTSDashboardPresentationResult')));

const Faqs = Loadable(lazy(() => import('pages/support/faqs')));
const Help = Loadable(lazy(() => import('pages/support/help')));
const Home = Loadable(lazy(() => import('pages/home')));
const Settings = Loadable(lazy(() => import('pages/settings')));

const Pricing = Loadable(lazy(() => import('pages/pricing/pricing')));
const Error404 = Loadable(lazy(() => import('pages/maintenance/404')));
const AddPayment = Loadable(lazy(() => import('pages/add-payment')));

const VideoAi = Loadable(lazy(() => import('pages/video-ai')));

const AffiliatesFinder = Loadable(lazy(() => import('pages/affiliate-community/affiliates-finder')));
const AffiliateCommunity = Loadable(lazy(() => import('pages/affiliate-community/my-community')));
const CampaignSetup = Loadable(lazy(() => import('pages/collaborations/campaign-setup')));
const CollaborationReview = Loadable(lazy(() => import('pages/collaborations/collaboration-review')));
const SamplesManagement = Loadable(lazy(() => import('pages/collaborations/samples-management')));
const CampaignSetupTiktokTab = Loadable(lazy(() => import('features/collaboration-setup/components/main_tts')));
const CampaignSetupYoutubeTab = Loadable(lazy(() => import('features/collaboration-setup/components/main_yts')));
const TTSSamplesManagement = Loadable(lazy(() => import('features/samples-management/components/main_tts')));
const YTSSamplesManagement = Loadable(lazy(() => import('features/samples-management/components/main_yts')));
const MyLists = Loadable(lazy(() => import('pages/affiliate-community/my-lists')));
const MyListDetail = Loadable(lazy(() => import('pages/affiliate-community/my-list-detail')));

const CreateSequence = Loadable(lazy(() => import('pages/crm/create-sequence')));
const MySequences = Loadable(lazy(() => import('pages/crm/my-sequences')));
const MyTemplates = Loadable(lazy(() => import('pages/crm/my-templates')));
const SequenceDetail = Loadable(lazy(() => import('pages/crm/sequence-detail')));
const TemplateDetail = Loadable(lazy(() => import('pages/crm/template-detail')));
const EditSequence = Loadable(lazy(() => import('pages/crm/edit-sequence')));
const DuplicateSequence = Loadable(lazy(() => import('pages/crm/duplicate-sequence')));

const AccountTabAccount = Loadable(lazy(() => import('sections/profiles/account/TabAccount')));
const AccountTabPassword = Loadable(lazy(() => import('sections/profiles/account/TabPassword')));

const Billing = Loadable(lazy(() => import('pages/profiles/billing')));
const BillingTabPaymentMethods = Loadable(lazy(() => import('features/pricing/components/TabPaymentMethods')));
const BillingTabPayments = Loadable(lazy(() => import('features/pricing/components/TabPayments')));

const MessagesCenter = Loadable(lazy(() => import('pages/message-center')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'home',
          element: <Home />
        },
        {
          path: 'settings',
          element: <Settings />
        },
        {
          path: 'affiliates',
          children: [
            { path: 'affiliates-finder', element: <AffiliatesFinder /> },
            { path: 'my-community', element: <AffiliateCommunity /> },
            { path: 'my-lists', element: <MyLists /> },
            { path: 'my-lists/editing/:id', element: <AffiliateCommunity /> },
            { path: 'my-lists/:id', element: <MyListDetail /> }
          ]
        },
        {
          path: 'collaborations',
          children: [
            {
              path: 'campaign-setup',
              element: <CampaignSetup />,
              children: [
                {
                  path: 'tiktok-shop',
                  element: <CampaignSetupTiktokTab />
                },
                {
                  path: 'youtube-shopping',
                  element: <CampaignSetupYoutubeTab />
                }
              ]
            },
            {
              path: 'collaboration-review',
              element: <CollaborationReview />
            },
            {
              path: 'samples-management',
              element: <SamplesManagement />,
              children: [
                {
                  path: 'tiktok-shop',
                  element: <TTSSamplesManagement />
                },
                {
                  path: 'youtube-shopping',
                  element: <YTSSamplesManagement />
                }
              ]
            }
          ]
        },
        {
          path: 'crm',
          children: [
            {
              path: 'create-sequence',
              element: <CreateSequence />
            },
            {
              path: 'create-sequence/:id',
              element: <CreateSequence />
            },
            { path: 'duplicate-sequence/:id', element: <DuplicateSequence /> },
            {
              path: 'edit-sequence/:id',
              element: <EditSequence />
            },
            {
              path: 'my-sequences',
              element: <MySequences />
            },
            {
              path: 'my-sequences/:id',
              element: <SequenceDetail />
            },
            {
              path: 'my-templates',
              element: <MyTemplates />
            },
            {
              path: 'my-templates/:id',
              element: <TemplateDetail />
            }
          ]
        },
        {
          path: 'video-ai',
          element: <VideoAi />
        },
        {
          path: 'data-analytics',
          element: <DataAnalytics />,
          children: [
            {
              path: 'tiktok-shop',
              element: <DataAnalyticsTiktokTab />
            },
            {
              path: 'youtube-shopping',
              element: <DataAnalyticsYoutubeTab />
            }
          ]
        },
        {
          path: 'profiles',
          children: [
            {
              path: 'account',
              children: [
                {
                  path: 'my-account',
                  element: <AccountTabAccount />
                },
                {
                  path: 'pricing',
                  element: <Pricing />
                },
                {
                  path: 'password',
                  element: <AccountTabPassword />
                }
              ]
            },
            {
              path: 'billing',
              element: <Billing />,
              children: [
                { path: 'payment-methods', element: <BillingTabPaymentMethods /> },
                { path: 'payments', element: <BillingTabPayments /> }
              ]
            }
          ]
        },
        {
          path: 'add-payment',
          element: <AddPayment />
        },
        {
          path: 'message-center',
          element: <MessagesCenter />
        },
        {
          path: 'support',
          children: [
            {
              path: 'help',
              element: <Help />
            },

            {
              path: 'faqs',
              element: <Faqs />
            }
          ]
        }
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <Error404 />
        }
      ]
    },
    // Catch-all route for 404
    {
      path: '*',
      element: <Error404 />
    }
  ]
};

export default MainRoutes;
